module.exports = __webpack_public_path__ + "img/project3_4.png.5c14e8e7.webp";